import Vue from 'vue';
import combineURLs from 'axios/lib/helpers/combineURLs';
import { VuePiriAxiosPlugin } from '@piri/axios-client';

import { hashUrl } from 'piri/utils';
import { useFixedBarLoading } from '@/helpers/loadings';
import { apiError } from './error/types/apiError';

Vue.use(VuePiriAxiosPlugin, {
  extend(client) {
    client.interceptors.request.use(
      result => {
        useFixedBarLoading().show(hashUrl(combineURLs(result.baseURL, result.url)));

        return result;
      },
      error => {
        useFixedBarLoading().hide(hashUrl(error.request.responseURL));
        apiError(error);
      },
    );

    client.interceptors.response.use(
      result => {
        useFixedBarLoading().hide(hashUrl(result.request.responseURL));

        return result;
      },
      error => {
        useFixedBarLoading().hide(hashUrl(error.request.responseURL));
        apiError(error);
      },
    );
  },
});
